import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import prefeitura from "@/assets/logo-da-prefeitura-750x375.png";
import slzVet from "@/assets/logo-dark.png";
import logo from "@/assets/logo-hospital-372x2550.png";
import { Bell, User } from "lucide-react";

export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll para o topo sempre que a rota mudar
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
   
      <div className="min-h-svh flex flex-col bg-gray-50">
        {/* Header */}
        <header className="bg-white/95 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-900/20">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16 sm:h-18"> 
              {/* Logo Section */}
              <div className="flex-shrink-0">
                <img 
                  src={logo} 
                  alt="Logo Hospital Veterinário" 
                  className="h-10 w-auto object-contain sm:h-12 lg:h-14"
                  loading="eager"
                />
              </div>
              
              {/* Actions Section */}
              <div className="flex items-center space-x-1 sm:space-x-2">
                <button 
                  onClick={() => navigate("/notifications")}
                  className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  aria-label="Notificações"
                >
                  <Bell size={20} className="text-gray-700 hover:text-blue-600" />
                </button>

                <button 
                  onClick={() => navigate("/perfil")}
                  className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 rounded-full hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  aria-label="Perfil do usuário"
                >
                  <User size={20} className="text-gray-700 hover:text-blue-600" />
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 w-full overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-6">
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 mt-auto sticky bottom-0">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
            <div className="flex items-center justify-center py-3 sm:py-4">
              {/* Logos das instituições */}
              <div className="flex items-center space-x-3 sm:space-x-4">
                <img
                  src={prefeitura}
                  alt="Logo da Prefeitura de São Luís"
                  className="h-6 sm:h-8 w-auto object-contain hover:scale-105 transition-transform duration-200"
                  loading="lazy"
                />
                <div className="w-px h-6 sm:h-8 bg-gray-300" />
                <img 
                  src={slzVet} 
                  alt="Logo SLZ Vet - Programa de Bem-estar Animal" 
                  className="h-6 sm:h-8 w-auto object-contain hover:scale-105 transition-transform duration-200"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </footer>
      </div>
 
  );
}
